export class ListAzureRegions200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureRegions200Response.attributeTypeMap;
    }
    constructor() {
    }
}
